<template>
  <div>
    <RowCard
      :theme="theme"
      style="position: relative"
      :style="item.status == 'Draft' ? { color: '#F15A29' } : { color: '#000' }"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <v-btn v-if="item.status === 'Draft'" small icon @click="onEdit">
          <Iconify
            style="color: #f15a29"
            icon="material-symbols:edit"
            size="15px"
          ></Iconify>
        </v-btn>

        <v-btn v-if="item.status === 'Draft'" small icon @click="onDelete">
          <Iconify
            style="color: #b1b1b1"
            icon="basil:trash-alt-solid"
            size="15px"
          ></Iconify>
        </v-btn>
        <v-btn v-if="item.status !== 'Draft'" small icon @click="onPreview">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
      </div>

      <div :style="{ width: headers[1].width, textAlign: headers[1].align }">
        {{ index + 1 }}
      </div>

      <div
        :style="{ width: headers[2].width, textAlign: headers[2].align }"
        class="text-decoration-underline"
      >
        #{{ item?.form_c?.doc_no }}
      </div>

      <div :style="{ width: headers[3].width, textAlign: headers[3].align }">
        <tooltip-text :text="item?.project_name" />
      </div>

      <div :style="{ width: headers[4].width, textAlign: headers[4].align }">
        <tooltip-text :text="item?.plan_name" />
      </div>

      <div :style="{ width: headers[5].width, textAlign: headers[5].align }">
        <tooltip-text :text="item?.created_by" />
      </div>
      
      <div
        :style="{
          width: headers[6].width,
          textAlign: headers[6].align,
          color: checkStatus(item?.status).color,
        }"
      >
        <div v-if="item.status === 'Submitted' && isRSP " class="d-flex flex-wrap gap-8">
            <Button
              theme="5"
              height="36px"
              class="px-md-3"
              @onClick="onUpdate('Reject')"
            >
              Reject
            </Button>

            <Button
              height="36px"
              class="px-md-3"
              @onClick="onUpdate('Accept')"
            >
              Accept 
            </Button>
          </div>
        <div v-else>{{ item.status }}</div>

      </div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content d-flex flex-column gap-12">
        <div class="d-flex justify-space-between">
          <div class="d-flex" style="gap: 12px">
            <div class="black--text font-type-bold" style="min-width: 125px">
              ชื่อโครงการ(อังกฤษ)
            </div>
            <div>
              {{ item.form_c?.project_section_general_info?.project_name_en || "-"}}
            </div>
          </div>
          <div class="d-flex" style="gap: 12px">
            <div class="black--text font-type-bold">งบประมาณโครงการ</div>
            <div class="text-end" style="min-width: 100px">
              {{ formatNumber(item.form_c?.budget_amount, 2) }} บาท
            </div>
          </div>
        </div>
        <div class="d-flex" style="gap: 12px">
          <div class="black--text font-type-bold" style="min-width: 125px">
            สร้างข้อเสนอ
          </div>
          <div>{{ toDateTimeFormat(item.created_at) }}</div>
        </div>
        <div class="d-flex" style="gap: 12px">
          <div class="black--text font-type-bold" style="min-width: 125px">
            แก้ไขล่าสุด
          </div>
          <div>{{ toDateFormat(item.updated_at) }}</div>
        </div>

        <!--        <v-layout justify-end>-->
        <!--          <v-flex shrink>-->
        <!--            <v-btn color="#e51610" outlined rounded depressed>-->
        <!--              <Iconify-->
        <!--                style="color: #e51610"-->
        <!--                icon="fluent:document-pdf-24-filled"-->
        <!--              ></Iconify>-->
        <!--              <span style="color: #e51610">Export PDF </span>-->
        <!--            </v-btn>-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { mapState } from "vuex";
import {
  toDateFormat,
  toDateTimeFormat,
  formatNumber,
} from "@/plugins/global-funcs";

export default {
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateFormat,
      toDateTimeFormat,
      formatNumber,
      theme: 2,
      rand: "cl-" + Math.random().toString().slice(2),
      isExpanded: false,
    };
  },
  computed: {
    ...mapState({
      isRSP: (state) => state.Auth.User.user_type === "RSP",
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    checkStatus(status) {
      if (status == "Submitted") {
        this.theme = 1;
        return {
          color: "#FBB040",
          text: "รอพิจารณา",
        };
      } else if (status == "Reject") {
        this.theme = 4;
        return {
          color: "#F15A29",
          text: "ปฏิเสธขยายเวลา",
        };
      } else if (status == "Approved") {
        this.theme = 3;
        return {
          color: "#5CB844",
          text: "อนุมัติขยายเวลา",
        };
      } else if (status == "Accept") {
        this.theme = 3;
        return {
          color: "#5CB844",
          text: "รับยื่น",
        };
      } else {
        // Draft
        this.theme = 2;
        return {
          color: "#F15A29",
          text: "แบบร่าง",
        };
      }
    },
    onEdit() {
      this.$router.push(
        `/usp/extend-time/${this.item.form_c_id}/form/${this.item.id}`
      );
    },
    onUpdate(status) {
      this.$emit("onUpdateStatus", status);
    },
    onDelete() {
      this.$emit("onDelete", this.item.id);
    },
    onPreview() {
      this.$router.push("/usp/extend-time/detail/" + this.item.id);
    },
    extendRequest() {},
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
